export default __webpack_public_path__ + "fr/static/media/account.6bfa4335.svg";